import { Maybe } from '@csp/csp-common-model';
import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';

type Props = {
  routesMap: Record<string, string>;
};

export const useMatchingRoutePath = ({ routesMap }: Props): Maybe<string> => {
  const location = useLocation();
  const routes = useMemo(() => Object.values(routesMap).map(path => ({ path })), [routesMap]);
  const matches = matchRoutes(routes, location);
  const routePathMatch = matches?.[0]?.route?.path;
  return routePathMatch;
};
